import { render } from "./VolumesTab.vue?vue&type=template&id=6cd31f96"
import script from "./VolumesTab.vue?vue&type=script&lang=js"
export * from "./VolumesTab.vue?vue&type=script&lang=js"

import exportComponent from "/opt/novus-cloud-ui/ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__